import React from "react";
import { Outlet } from "react-router-dom";
import Drawer from "../Pages/Drawer/Drawer";
import Feature from "../Pages/Feature/Feature";
import Footer from "../Pages/Footer/Footer";
import Header from "../Pages/Header/Header";
import Hero from "../Pages/Hero/Hero";
import Prising from "../Pages/Prising/Prising";
import SideBar from "../Pages/SideBar/SideBar";

const Main = () => {
  return (
    <div>
      <Outlet></Outlet>
      <div className="fixed md:hidden left-2/4 right-2/4 bottom-5">
        <Header></Header>
      </div>
    </div>
  );
};

export default Main;
